import { useTheme } from '@mui/material';
const useDashboardStyles = () => {
    const theme = useTheme();
    return {
        pageHeaderStyles: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            py: 2,
            px: 0
        },
        rightSectionStyles: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            pt: '15px',
            gap: 1.25, // 10px
            borderRadius: 1.5,
            background: theme.palette.background.paper,
            // boxShadow: theme.customShadows.card
        },
        filterSectionStyles: {
            display: 'flex',
            alignItems: 'center',
            gap: 1
        },
        incidentsGraphStyles: {
            py: 2,
            border: `1px solid ${theme.palette.action.active}`,
            px: 3,
            position: 'relative'
        },
        recentIncidentsContainerStyles: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5,
            p: 2,
            borderRadius: 1.5,
            border: `1px solid ${theme.palette.action.active}`,
            background: theme.palette.background.paper,
            // boxShadow: theme.customShadows.card
        },
        headerStyles: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 3,
            px: 2
        },
        filterButtonStyles: {},
        leftSectionStyles: {
            height: 'calc(100dvh - 240px)',
            overflowY: 'auto',
            scrollbarWidth: 'none' /* For Firefox */,
            '-ms-overflow-style': 'none' /* For Internet Explorer 10+ */,
            pr: 2
        }
    };
};
export default useDashboardStyles;
